import z from 'zod';

export const InventoryGroupSummarySchema = z.object({
    id: z.string(),
    name: z.string(),
});

export type InventoryGroupSummary = z.infer<typeof InventoryGroupSummarySchema>;
